import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import { useDispatch } from "react-redux";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const InternalMultiApprovalDeclined = () => {
  const [declinedPageData, setdeclinedPageData] = useState([]);
  const [declinedPageID, setdeclinedPageID] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const lengthVarForConditonOne = 1;

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData"),
    );

    if (storedSelectedApproval) {
      setdeclinedPageData(storedSelectedApproval?.selectedSendTransactions);
      setdeclinedPageID(storedSelectedApproval.selectedTransactions);
    } else {
      setdeclinedPageData([]);
      setdeclinedPageID([]);
    }
  }, []);

  const buttonRows = [
    [
      {
        btnText: "Go to approval ",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.GO_TO_APPROVAL,
        imgColor: "var(--positive-bg)",
        handleFunction: () =>
          navigate(
            "/internal_transaction_dashboard/internal_transaction_multi_approval",
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/internal_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];
  const buildRows = (txn) => [
    {
      leftTitle: (
        <span className=" font-semibold">
          INR <FormatAmount price={txn?.amount || 0} />
        </span>
      ),
      leftSubTitle: "Amount",
      rightIcon: true,
    },
    {
      leftTitle: formatAccountNumber(txn?.owner_account_bank_acc_no),
      leftSubTitle: "Source account",
      ifsc: txn?.owner_account_ifsc_code,
    },
    {
      leftTitle: formatAccountNumber(txn?.internal_account_bank_acc_no),
      leftSubTitle: "Destination account",
      ifsc: txn?.internal_account_ifsc_code,
    },
  ];

  const TransactionList = ({ transactions }) => (
    <>
      {transactions?.map((txn, i) => (
        <InfoCard
          key={txn?.txn_id || i}
          bgColor="var(--positive-card)"
          borderColor="var(--positive-bg)"
          hoverable="white"
          showRowDivider={true}
          rowBorderColor="var(--positive-bg)"
          onClick={() =>
            navigate(
              `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
            )
          }
          rows={buildRows(txn)}
        />
      ))}
    </>
  );

  return (
    <>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={
          declinedPageID?.length === lengthVarForConditonOne
            ? "Transaction rejected successfully."
            : declinedPageID?.length > lengthVarForConditonOne
              ? "Transactions rejected successfully."
              : "Transactions rejected and sent for recreation"
        }
      >
        <TabsWeapperSection
          title={`Rejected transactions - ${declinedPageID?.length || declinedPageData?.length}`}
        >
          <TransactionList transactions={declinedPageData} />
        </TabsWeapperSection>
      </StatusContainer>
      {/* Component implementation */}
    </>
  );
};

export default InternalMultiApprovalDeclined;
